import { fieldName } from './paymentCard';

export const POLLING_INTERVAL = 3000;

export const DEFAULT_VALUES = {
  certificate: undefined,
  country: undefined,
  amount: undefined,
  paymentMethod: '',
  offer: false,
  cardData: {
    [fieldName.CARD_NUMBER]: '',
    [fieldName.EXPIRATION_DATE]: '',
    [fieldName.SECURE_CODE]: '',
    [fieldName.CARDHOLDER]: '',
    [fieldName.EMAIL]: '',
  },
  ruData: {
    [fieldName.EMAIL]: '',
  },
  steamData: {
    login: '',
    amount: 50,
  },
  promocode: '',
};
